import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e73e700"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "flex-row align-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title_text" }, "运营数据", -1))
const _hoisted_4 = { class: "sub_title_text" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_6 = { class: "content-title-text up-content" }
const _hoisted_7 = { class: "flex-row" }
const _hoisted_8 = { class: "flex-row space-between align-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666"} }, "累计成交：", -1))
const _hoisted_10 = { style: {"font-size":"18px","color":"#666"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_12 = { class: "content-title-text up-content" }
const _hoisted_13 = { class: "flex-row" }
const _hoisted_14 = { class: "flex-row space-between align-end" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666"} }, "累计成交：", -1))
const _hoisted_16 = { style: {"font-size":"18px","color":"#666"} }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_18 = { class: "content-title-text down-content" }
const _hoisted_19 = { class: "flex-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "%", -1))
const _hoisted_21 = { class: "flex-row space-between align-end" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666"} }, "累计好评：", -1))
const _hoisted_23 = { style: {"font-size":"18px","color":"#666"} }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_25 = { class: "content-title-text up-content" }
const _hoisted_26 = { class: "flex-row" }
const _hoisted_27 = { class: "flex-row space-between align-end" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666"} }, "累计投诉：", -1))
const _hoisted_29 = { style: {"font-size":"18px","color":"#666"} }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_31 = { class: "flex-row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "用户访问量", -1))
const _hoisted_33 = { class: "content-title-text up-content" }
const _hoisted_34 = { class: "flex-row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前活跃", -1))
const _hoisted_36 = { class: "content-title-text warning-content" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"6px"} }, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_39 = { class: "flex-row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "司机访问量", -1))
const _hoisted_41 = { class: "content-title-text up-content" }
const _hoisted_42 = { class: "flex-row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前活跃", -1))
const _hoisted_44 = { class: "content-title-text warning-content" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"6px"} }, null, -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_47 = { class: "content-title-text down-content" }
const _hoisted_48 = { class: "flex-row" }
const _hoisted_49 = { class: "flex-row space-between align-end" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666"} }, "用户总数", -1))
const _hoisted_51 = { style: {"font-size":"18px","color":"#666"} }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_53 = { class: "content-title-text" }
const _hoisted_54 = { class: "flex-row" }
const _hoisted_55 = { class: "flex-row space-between align-end" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666"} }, "司机总数：", -1))
const _hoisted_57 = { style: {"font-size":"18px","color":"#666"} }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_59 = { class: "content-title-text down-content" }
const _hoisted_60 = { class: "flex-row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "辆", -1))
const _hoisted_62 = { class: "flex-row space-between align-end" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666"} }, "车辆总计：", -1))
const _hoisted_64 = { style: {"font-size":"18px","color":"#666"} }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "orderChart",
  style: {"width":"100%","height":"100%"}
}, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-bottom":"0"} }, "订单营业额统计", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-row",
  style: {"margin-top":"15px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "orderExpressTypeChart",
    class: "flex-1",
    style: {"height":"330px"}
  }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "moneyExpressTypeChart",
    class: "flex-1",
    style: {"height":"330px"}
  })
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "userActiveChart",
  style: {"width":"100%","height":"530px"}
}, null, -1))
const _hoisted_69 = {
  key: 1,
  class: "flex-row align-center",
  style: {"height":"35px"}
}
const _hoisted_70 = {
  key: 1,
  class: "flex-row align-center",
  style: {"height":"35px"}
}
const _hoisted_71 = { class: "flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_rise_outlined = _resolveComponent("rise-outlined")!
  const _component_fall_outlined = _resolveComponent("fall-outlined")!
  const _component_calendar_outlined = _resolveComponent("calendar-outlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_transaction_outlined = _resolveComponent("transaction-outlined")!
  const _component_frown_outlined = _resolveComponent("frown-outlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_rate = _resolveComponent("a-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { class: "top-box" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, "更新时间：" + _toDisplayString(_ctx.currentDateString), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      class: "inline-card statics-card-box",
                      title: "成交订单（笔）"
                    }, {
                      extra: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "blue" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.todayData.order_num), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_a_statistic, {
                            title: "昨日",
                            value: _ctx.yesterdayData.order_num,
                            suffix: "",
                            "value-style": { color: '#333',fontSize: '18px' },
                            style: {"margin-right":"10px"}
                          }, null, 8, ["value"]),
                          _createVNode(_component_a_statistic, {
                            title: "较昨日",
                            value: _ctx.getStaticsCss(_ctx.todayData.order_num, _ctx.yesterdayData.order_num).divide,
                            "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.order_num, _ctx.yesterdayData.order_num).color,fontSize: '16px' },
                            style: {"margin-right":"10px"}
                          }, _createSlots({
                            suffix: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.order_num, _ctx.yesterdayData.order_num).text) + " ", 1),
                              _createVNode(_component_calendar_outlined)
                            ]),
                            _: 2
                          }, [
                            (_ctx.getStaticsCss(_ctx.todayData.order_num, _ctx.yesterdayData.order_num).mode)
                              ? {
                                  name: "prefix",
                                  fn: _withCtx(() => [
                                    (_ctx.getStaticsCss(_ctx.todayData.order_num, _ctx.yesterdayData.order_num).isAdd)
                                      ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                                      : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                                  ])
                                }
                              : undefined
                          ]), 1032, ["value", "value-style"])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.sumData.order_num), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      class: "inline-card statics-card-box",
                      title: "营业额（元）"
                    }, {
                      extra: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "blue" }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.todayData.order_amount), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_a_statistic, {
                            title: "昨日",
                            value: _ctx.yesterdayData.order_amount,
                            precision: 2,
                            suffix: "",
                            "value-style": { color: '#333',fontSize: '18px' },
                            style: {"margin-right":"10px"}
                          }, null, 8, ["value"]),
                          _createVNode(_component_a_statistic, {
                            title: "较昨日",
                            precision: 2,
                            value: _ctx.getStaticsCss(_ctx.todayData.order_amount, _ctx.yesterdayData.order_amount).divide,
                            "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.order_amount, _ctx.yesterdayData.order_amount).color,fontSize: '16px' },
                            style: {"margin-right":"10px"}
                          }, _createSlots({
                            suffix: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.order_amount, _ctx.yesterdayData.order_amount).text) + " ", 1),
                              _createVNode(_component_transaction_outlined)
                            ]),
                            _: 2
                          }, [
                            (_ctx.getStaticsCss(_ctx.todayData.order_amount, _ctx.yesterdayData.order_amount).mode)
                              ? {
                                  name: "prefix",
                                  fn: _withCtx(() => [
                                    (_ctx.getStaticsCss(_ctx.todayData.order_amount, _ctx.yesterdayData.order_amount).isAdd)
                                      ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                                      : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                                  ])
                                }
                              : undefined
                          ]), 1032, ["value", "value-style"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("p", _hoisted_16, "￥ " + _toDisplayString(_ctx.sumData.order_amount), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      class: "inline-card statics-card-box",
                      title: "订单好评率（单）"
                    }, {
                      extra: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "blue" }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.todayData.order_num_good) + "/" + _toDisplayString(_ctx.todayData.order_num), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_a_statistic, {
                            title: "昨日",
                            value: _ctx.yesterdayData.order_num_good,
                            "value-style": { color: '#333',fontSize: '18px' },
                            style: {"margin-right":"10px"}
                          }, {
                            suffix: _withCtx(() => [
                              _createElementVNode("span", null, "/" + _toDisplayString(_ctx.yesterdayData.order_num), 1)
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_a_statistic, {
                            title: "较昨日",
                            value: _ctx.getStaticsCss(_ctx.todayData.order_num_good / _ctx.todayData.order_num, _ctx.yesterdayData.order_num_good / _ctx.yesterdayData.order_num).divide,
                            precision: 2,
                            "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.order_num_good / _ctx.todayData.order_num, _ctx.yesterdayData.order_num_good / _ctx.yesterdayData.order_num).color,fontSize: '16px' },
                            style: {"margin-right":"10px"}
                          }, _createSlots({
                            suffix: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.order_num_good / _ctx.todayData.order_num, _ctx.yesterdayData.order_num_good / _ctx.yesterdayData.order_num).text) + " ", 1),
                              _hoisted_20
                            ]),
                            _: 2
                          }, [
                            (_ctx.getStaticsCss(_ctx.todayData.order_num_good / _ctx.todayData.order_num, _ctx.yesterdayData.order_num_good / _ctx.yesterdayData.order_num).mode)
                              ? {
                                  name: "prefix",
                                  fn: _withCtx(() => [
                                    (_ctx.getStaticsCss(_ctx.todayData.order_num_good / _ctx.todayData.order_num, _ctx.yesterdayData.order_num_good / _ctx.yesterdayData.order_num).isAdd)
                                      ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                                      : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                                  ])
                                }
                              : undefined
                          ]), 1032, ["value", "value-style"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.sumData.order_num_good) + "/" + _toDisplayString(_ctx.sumData.order_num), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      class: "inline-card statics-card-box",
                      title: "订单投诉（次）"
                    }, {
                      extra: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "blue" }, {
                          default: _withCtx(() => [
                            _hoisted_24
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.todayData.order_num_complaint), 1),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_a_statistic, {
                            title: "昨日",
                            value: _ctx.yesterdayData.order_num_complaint,
                            suffix: "",
                            "value-style": { color: '#333',fontSize: '18px' },
                            style: {"margin-right":"10px"}
                          }, null, 8, ["value"]),
                          _createVNode(_component_a_statistic, {
                            title: "较昨日",
                            value: _ctx.getStaticsCss(_ctx.todayData.order_num_complaint, _ctx.yesterdayData.order_num_complaint).divide,
                            "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.order_num_complaint, _ctx.yesterdayData.order_num_complaint).color,fontSize: '16px' },
                            style: {"margin-right":"10px"}
                          }, _createSlots({
                            suffix: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.order_num_complaint, _ctx.yesterdayData.order_num_complaint).text) + " ", 1),
                              _createVNode(_component_frown_outlined)
                            ]),
                            _: 2
                          }, [
                            (_ctx.getStaticsCss(_ctx.todayData.order_num_complaint, _ctx.yesterdayData.order_num_complaint).mode)
                              ? {
                                  name: "prefix",
                                  fn: _withCtx(() => [
                                    (_ctx.getStaticsCss(_ctx.todayData.order_num_complaint, _ctx.yesterdayData.order_num_complaint).isAdd)
                                      ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                                      : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                                  ])
                                }
                              : undefined
                          ]), 1032, ["value", "value-style"])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.sumData.order_num_complaint), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, {
      gutter: 16,
      style: {"margin-top":"16px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              class: "inline-card statics-card-box",
              title: "用户活跃度（人）"
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_tag, { color: "blue" }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", null, [
                    _hoisted_32,
                    _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.todayData.user_active_num), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_a_statistic, {
                        title: "昨日",
                        value: _ctx.yesterdayData.user_active_num,
                        suffix: "",
                        "value-style": { color: '#333',fontSize: '18px' },
                        style: {"margin-right":"10px"}
                      }, null, 8, ["value"]),
                      _createVNode(_component_a_statistic, {
                        title: "较昨日",
                        value: _ctx.getStaticsCss(_ctx.todayData.user_active_num, _ctx.yesterdayData.user_active_num).divide,
                        "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.user_active_num, _ctx.yesterdayData.user_active_num).color,fontSize: '16px' },
                        style: {"margin-right":"10px"}
                      }, _createSlots({
                        suffix: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.user_active_num, _ctx.yesterdayData.user_active_num).text), 1)
                        ]),
                        _: 2
                      }, [
                        (_ctx.getStaticsCss(_ctx.todayData.user_active_num, _ctx.yesterdayData.user_active_num).mode)
                          ? {
                              name: "prefix",
                              fn: _withCtx(() => [
                                (_ctx.getStaticsCss(_ctx.todayData.user_active_num, _ctx.yesterdayData.user_active_num).isAdd)
                                  ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                                  : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                              ])
                            }
                          : undefined
                      ]), 1032, ["value", "value-style"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_35,
                    _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.todayData.user_active_num), 1)
                  ])
                ]),
                _hoisted_37
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              class: "inline-card statics-card-box",
              title: "司机活跃度（人）"
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_tag, { color: "blue" }, {
                  default: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", null, [
                    _hoisted_40,
                    _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.todayData.courier_active_num), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_a_statistic, {
                        title: "昨日",
                        value: _ctx.yesterdayData.courier_active_num,
                        suffix: "",
                        "value-style": { color: '#333',fontSize: '18px' },
                        style: {"margin-right":"10px"}
                      }, null, 8, ["value"]),
                      _createVNode(_component_a_statistic, {
                        title: "较昨日",
                        value: _ctx.getStaticsCss(_ctx.todayData.courier_active_num, _ctx.yesterdayData.courier_active_num).divide,
                        "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.courier_active_num, _ctx.yesterdayData.courier_active_num).color,fontSize: '16px' },
                        style: {"margin-right":"10px"}
                      }, _createSlots({
                        suffix: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.courier_active_num, _ctx.yesterdayData.courier_active_num).text), 1)
                        ]),
                        _: 2
                      }, [
                        (_ctx.getStaticsCss(_ctx.todayData.courier_active_num, _ctx.yesterdayData.courier_active_num).mode)
                          ? {
                              name: "prefix",
                              fn: _withCtx(() => [
                                (_ctx.getStaticsCss(_ctx.todayData.courier_active_num, _ctx.yesterdayData.courier_active_num).isAdd)
                                  ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                                  : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                              ])
                            }
                          : undefined
                      ]), 1032, ["value", "value-style"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_43,
                    _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.todayData.courier_active_num), 1)
                  ])
                ]),
                _hoisted_45
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              class: "inline-card statics-card-box",
              title: "新增用户（人）"
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_tag, { color: "blue" }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.todayData.new_user_num), 1),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_a_statistic, {
                    title: "昨日",
                    value: _ctx.yesterdayData.new_user_num,
                    suffix: "",
                    "value-style": { color: '#333',fontSize: '18px' },
                    style: {"margin-right":"10px"}
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_statistic, {
                    title: "较昨日",
                    value: _ctx.getStaticsCss(_ctx.todayData.new_user_num, _ctx.yesterdayData.new_user_num).divide,
                    suffix: "",
                    "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.new_user_num, _ctx.yesterdayData.new_user_num).color,fontSize: '16px' },
                    style: {"margin-right":"10px"}
                  }, _createSlots({
                    suffix: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.new_user_num, _ctx.yesterdayData.new_user_num).text), 1)
                    ]),
                    _: 2
                  }, [
                    (_ctx.getStaticsCss(_ctx.todayData.new_user_num, _ctx.yesterdayData.new_user_num).mode)
                      ? {
                          name: "prefix",
                          fn: _withCtx(() => [
                            (_ctx.getStaticsCss(_ctx.todayData.new_user_num, _ctx.yesterdayData.new_user_num).isAdd)
                              ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                          ])
                        }
                      : undefined
                  ]), 1032, ["value", "value-style"])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.sumData.new_user_num), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              class: "inline-card statics-card-box",
              title: "新增司机（人）"
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_tag, { color: "blue" }, {
                  default: _withCtx(() => [
                    _hoisted_52
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.todayData.new_courier_num), 1),
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_a_statistic, {
                    title: "昨日",
                    value: _ctx.yesterdayData.new_courier_num,
                    suffix: "",
                    "value-style": { color: '#333',fontSize: '18px' },
                    style: {"margin-right":"10px"}
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_statistic, {
                    title: "较昨日",
                    value: _ctx.getStaticsCss(_ctx.todayData.new_courier_num, _ctx.yesterdayData.new_courier_num).divide,
                    "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.new_courier_num, _ctx.yesterdayData.new_courier_num).color,fontSize: '16px' },
                    style: {"margin-right":"10px"}
                  }, _createSlots({
                    suffix: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.new_courier_num, _ctx.yesterdayData.new_courier_num).text), 1)
                    ]),
                    _: 2
                  }, [
                    (_ctx.getStaticsCss(_ctx.todayData.new_courier_num, _ctx.yesterdayData.new_courier_num).mode)
                      ? {
                          name: "prefix",
                          fn: _withCtx(() => [
                            (_ctx.getStaticsCss(_ctx.todayData.new_courier_num, _ctx.yesterdayData.new_courier_num).isAdd)
                              ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                          ])
                        }
                      : undefined
                  ]), 1032, ["value", "value-style"])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.sumData.new_courier_num), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              class: "inline-card statics-card-box",
              title: "新增车辆（辆）"
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_tag, { color: "blue" }, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.todayData.new_vehicle_num), 1),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_a_statistic, {
                    title: "昨日",
                    value: _ctx.yesterdayData.new_vehicle_num,
                    "value-style": { color: '#333',fontSize: '18px' },
                    style: {"margin-right":"10px"}
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_statistic, {
                    title: "较昨日",
                    value: _ctx.getStaticsCss(_ctx.todayData.new_vehicle_num, _ctx.yesterdayData.new_vehicle_num).divide,
                    "value-style": { color: _ctx.getStaticsCss(_ctx.todayData.new_vehicle_num, _ctx.yesterdayData.new_vehicle_num).color,fontSize: '16px' },
                    style: {"margin-right":"10px"}
                  }, _createSlots({
                    suffix: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getStaticsCss(_ctx.todayData.new_vehicle_num, _ctx.yesterdayData.new_vehicle_num).text) + " ", 1),
                      _hoisted_61
                    ]),
                    _: 2
                  }, [
                    (_ctx.getStaticsCss(_ctx.todayData.new_vehicle_num, _ctx.yesterdayData.new_vehicle_num).mode)
                      ? {
                          name: "prefix",
                          fn: _withCtx(() => [
                            (_ctx.getStaticsCss(_ctx.todayData.new_vehicle_num, _ctx.yesterdayData.new_vehicle_num).isAdd)
                              ? (_openBlock(), _createBlock(_component_rise_outlined, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_fall_outlined, { key: 1 }))
                          ])
                        }
                      : undefined
                  ]), 1032, ["value", "value-style"])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.sumData.new_vehicle_num), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, {
      gutter: 16,
      style: {"margin-top":"16px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: 18,
          style: {"height":"793px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { style: {"height":"500px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, {
                  class: "inline-card statics-line-card-box",
                  title: "订单营业额变化"
                }, {
                  default: _withCtx(() => [
                    _hoisted_65
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, {
              gutter: 16,
              style: {"margin-top":"16px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      class: "inline-card statics-line-card-box",
                      title: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_66,
                        _createVNode(_component_a_tabs, {
                          activeKey: _ctx.activeKey,
                          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
                          onChange: _ctx.initPieChart
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staticsTypeTabs, (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: item.id,
                                tab: item.name
                              }, null, 8, ["tab"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["activeKey", "onChange"]),
                        _hoisted_67
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, {
              gutter: 16,
              style: {"margin-top":"16px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      class: "inline-card statics-line-card-box",
                      title: "活跃度变化"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_68
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              style: {"overflow":"hidden"},
              class: "inline-nomargin-card statics-card-box",
              title: "接单量司机排名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: _ctx.driverOrderNumberList,
                  columns: _ctx.driverColumns,
                  loading: _ctx.loading,
                  pagination: false
                }, {
                  bodyCell: _withCtx(({ column, text, index, record }) => [
                    (column.key === 'id')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(index + 1), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'name')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          (record.head_img)
                            ? (_openBlock(), _createBlock(_component_ImageView, {
                                key: 0,
                                width: 35,
                                height: 35,
                                style: {"border-radius":"50%","overflow":"hidden","margin-right":"5px"},
                                "image-url": record.head_img
                              }, null, 8, ["image-url"]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(text), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, {
              style: {"overflow":"hidden","margin-top":"16px"},
              class: "inline-nomargin-card statics-card-box",
              title: "好评司机排名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: _ctx.driverRatingList,
                  columns: _ctx.driverCommentColumns,
                  loading: _ctx.loading,
                  pagination: false
                }, {
                  bodyCell: _withCtx(({ column, text, index, record }) => [
                    (column.key === 'id')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(index + 1), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'name')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          (record.head_img)
                            ? (_openBlock(), _createBlock(_component_ImageView, {
                                key: 0,
                                width: 35,
                                height: 35,
                                style: {"border-radius":"50%","overflow":"hidden","margin-right":"5px"},
                                "image-url": record.head_img
                              }, null, 8, ["image-url"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_71, [
                            _createTextVNode(_toDisplayString(text) + " ", 1),
                            _createVNode(_component_a_rate, {
                              disabled: "",
                              value: _ctx.getStar(record),
                              "allow-half": ""
                            }, null, 8, ["value"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (column.key === 'stars_total')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(record.consignment_total ? (text / record.consignment_total).toFixed(2) : 0), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}